
































































































import Vue from "vue";
import Component from "vue-class-component";

import { TeamType } from "../store/interfaces";

@Component
export default class CurrRound extends Vue {
  // DATA
  current = 1;
  teamName = "";
  teamNum = "";
  social = false;
  teamRight = "";
  double = false;
  personPoints = "";
  sevenTotal = "10";
  penPoints = false;

  // COMPUTED
  get teamArray() {
    return this.$store.state.teams;
  }

  get graded() {
    return this.$store.state.teams.filter((team: TeamType) => {
      return team.rounds[this.current - 1].graded;
    });
  }

  get roundTotal() {
    switch (this.current) {
      case 1:
        return 6;

      case 2:
        return 8;

      case 3:
        return 6;

      case 4:
        return 10;

      case 5:
        return 10;

      case 6:
        return 10;

      case 7:
        return parseInt(this.sevenTotal);

      default:
        return 0;
    }
  }

  // METHODS
  reset() {
    this.teamNum = "";
    this.teamRight = "";
    this.double = false;
    this.personPoints = "";
    this.penPoints = false;
  }

  nextRound() {
    this.current++;
    this.reset();
  }

  previousRound() {
    this.current--;
    this.reset();
  }

  scoreRound() {
    let newTeamNum = false;
    const doesTeamExist =
      this.teamArray.filter((team: TeamType) => team.teamName === this.teamName)
        .length === 1;
    if (this.current === 1 && !doesTeamExist) {
      this.addTeam();
    }
    const thisTeamNameArray = this.teamArray.map(
      (team: TeamType) => team.teamName
    );
    const thisTeamIndex = thisTeamNameArray.indexOf(this.teamName);
    if (thisTeamIndex < 0) {
      alert(`"${this.teamName}" is not a team!`);
    } else {
      let gradedScore = parseInt(this.teamRight);

      if (this.current === 4) {
        gradedScore = parseInt(this.personPoints);
        this.teamRight = this.personPoints;
      }

      if (this.double) {
        this.roundTotal !== parseInt(this.teamRight)
          ? (gradedScore = 0)
          : (gradedScore = 2 * this.roundTotal);
      }

      if (
        parseInt(this.teamNum) > 0 &&
        !this.teamArray[thisTeamIndex].teamNum
      ) {
        newTeamNum = true;
        gradedScore = gradedScore + 2;
        this.$store.commit("updateNum", {
          index: thisTeamIndex,
          value: this.teamNum
        });
      }

      if (this.current === 7 && this.penPoints) {
        gradedScore = gradedScore + 2;
      }

      this.$store.commit("updateRounds", {
        index: thisTeamIndex,
        round: this.current,
        score: gradedScore,
        breakdown: {
          correctAnswers: this.teamRight,
          doubleDown: this.double,
          bonus: newTeamNum || this.penPoints
        }
      });

      this.reset();
      this.teamName = "";
      const element = document.getElementById("curr-team") as HTMLInputElement;
      element.select();
    }
  }

  addTeam() {
    this.$store.commit("pushTeam", {
      teamName: this.teamName,
      teamNumber: "00000",
      rounds: [
        {
          number: 1,
          gained: 0
        },
        {
          number: 2,
          gained: 0
        },
        {
          number: 3,
          gained: 0
        },
        {
          number: 4,
          gained: 0
        },
        {
          number: 5,
          gained: 0
        },
        {
          number: 6,
          gained: 0
        },
        {
          number: 7,
          gained: 0
        }
      ],
      total: 0
    })
  }
}
